import { i18n } from '@tt4b/ttam-i18n';

import NoneFace from '@tt4b/ttam-assets/src/svgs/splittest/split-test-power-none.svg';
import CryFace from '@tt4b/ttam-assets/src/svgs/splittest/split-test-power-cry.svg';
import SmileFace from '@tt4b/ttam-assets/src/svgs/splittest/split-test-power-smile.svg';
import LaughFace from '@tt4b/ttam-assets/src/svgs/splittest/split-test-power-laugh.svg';

export const powerConfig = () => [
  {
    value: 0,
    face: CryFace,
    dotColor: '#1DCDDB',
    estimateText: i18n.t('module_split_test_power_insufficient'),
    estimateHint: i18n.t('module_split_test_power_insufficient_hint'),
  },
  {
    value: 0.6,
    face: SmileFace,
    dotColor: '#3A55F7',
    estimateText: i18n.t('module_split_test_power_relatively_low'),
    estimateHint: i18n.t('module_split_test_power_relatively_low_hint'),
  },
  {
    value: 0.8,
    face: LaughFace,
    dotColor: '#FE0251',
    estimateText: i18n.t('module_split_test_power_sufficient'),
    estimateHint: i18n.t('module_split_test_power_sufficient_hint'),
  },
];

// power 值为0 特殊处理
export const nonePower = {
  face: NoneFace,
  dotColor: '#666',
  estimateText: '',
  estimateHint: '',
};
